import React, { useState } from 'react';

import styled from 'styled-components';
import Header from '../../Molecule/Card/CardHeader';
import Title from '../../Molecule/Card/CardTitle/ChartTitle';
import LocalMapLegend from '../../Molecule/Chart/Legend/LocalMapLegend';
import LocalMapChart from '../../Molecule/Chart/LocalMapChart';
import Spinner from '../../Molecule/Spinner';

const Component = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 100%;
  height: 100%;
  min-height: 579px;
  padding: 24px 24px 40px 24px;
  border-radius: 16px;
`;

const Body = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  margin-top: 24px;
`;

interface LocalMapChartCardProps {
  isLoading: boolean;
  data: {
    total: number;
    old: number;
    new: number;
    local_variant_en: string;
    local_variant_ko: string;
  }[];
}

const LocalMapChartCard = ({ isLoading, data }: LocalMapChartCardProps) => {
  const [max, setMax] = useState(0);
  return (
    <Component>
      <Header>
        <Title title="시도별 방문통계" />
      </Header>
      <Body>
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <LocalMapChart data={data} setMax={setMax} />
            <LocalMapLegend max={max} />
          </>
        )}
      </Body>
    </Component>
  );
};

export default LocalMapChartCard;
